import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { AddLocationUser } from 'domain/usecases/add-location-user';
import { RemoteAddLocationUser } from 'data/usecases/add-location-user';

export const makeRemoteAddLocationUser = (): AddLocationUser => {
  return new RemoteAddLocationUser(makeApiUrl('/addLocationUser'), makeAuthorizeHttpClientDecorator());
};
